import {
  remommandSize,
  browseProduct,
  similarProducts
} from 'src/app/queries/queries'

const fetchRecommandSize = (productId, success) => (dispatch, getState) => {
  let state = getState()
  const {
      bra_size,
      height_inches,
      weight,
      bust_size_number
    } = state.customer.style,
    isShowRecommendMessage = !!(
      height_inches &&
      weight &&
      (bra_size || bust_size_number)
    )
  const action = {
    type: 'API:FETCH:RECOMMAND:SIZE',
    API: true,
    url: '/api/query',
    success,
    data: {
      query: remommandSize,
      variables: {
        product_id: productId
      },
      isShowRecommendMessage
    }
  }
  dispatch(action)
}

const fetchRealtimeRecommended = (productId, success) => {
  return {
    type: 'API:FETCH:RECOMMAND:SIZE',
    API: true,
    url: '/api/query',
    success,
    data: {
      query: remommandSize,
      variables: {
        product_id: productId
      }
    }
  }
}

// [deprecated] 已被迁移
const fetchBrowseProduct = (productId, success, error = () => {}) => (
  dispatch,
  getState
) => {
  const {
      bra_size,
      height_inches,
      weight,
      bust_size_number
    } = getState().customer.style,
    isShowRecommendMessage = !!(
      height_inches &&
      weight &&
      (bra_size || bust_size_number)
    )
  const acitons = {
    type: 'API:PRODUCTS:FETCH',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: browseProduct,
      variables: {
        id: productId,
        product_id: productId
      },
      isShowRecommendMessage
    },
    success,
    error
  }
  dispatch(acitons)
}

// [deprecated] 已被迁移
const fetctSimilarProducts = (id, in_stock) => ({
  type: 'API:GET:SIMILAR:PRODUCTS',
  API: true,
  url: '/api/query',
  method: 'POST',
  data: {
    query: similarProducts,
    variables: {
      id,
      in_stock
    }
  }
})

export default {
  fetchRecommandSize,
  fetchBrowseProduct,
  fetctSimilarProducts,
  fetchRealtimeRecommended
}
